// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"8d54db64","137":"dd673d0d","232":"b56788ab","500":"82b06a0d","603":"f8c2cd7e","692":"f587741d","771":"eb943b7f"}[chunkId] + ".chunk.js";
};